@if (isToday() && nowTimeStepPosition() !== null) {
  <div
    class="pointer-events-none absolute inset-x-0 z-9"
    [style.top]="nowTimeStepPosition()">
    <!--
      Both marks hang off the same y and centre themselves on it with
      -translate-y-1/2, so neither one's placement depends on the other's
      thickness. Drawing the line as a bordered box instead would shift the dot:
      an absolutely positioned child anchors to the padding box, which starts
      below the border.
    -->
    <div
      data-testid="now-line"
      class="bg-danger absolute inset-x-0 top-0 h-[1.5px] -translate-y-1/2"></div>
    <span
      data-testid="now-dot"
      class="bg-danger absolute top-0 left-0 size-[7px] -translate-x-1/2 -translate-y-1/2 rounded-full"></span>
  </div>
}
